import { render, staticRenderFns } from "./MarkerInstitutionContent.vue?vue&type=template&id=89d93e66&scoped=true&"
import script from "./MarkerInstitutionContent.vue?vue&type=script&lang=js&"
export * from "./MarkerInstitutionContent.vue?vue&type=script&lang=js&"
import style0 from "./MarkerInstitutionContent.vue?vue&type=style&index=0&id=89d93e66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d93e66",
  null
  
)

export default component.exports